import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import DrawerCom from "../../Drawer/DrawerCom"

import { ScrollOutBoxWrap, DrawerWinOneTileWrap, DrawerWinTwoTileWrap, ListBottomGradientWrap, ListTopGradientWrap, PaddingLeftRightWrap, ScrollBoxWrap } from "../../Drawer/DrawerStyle"
import { useCallback, useEffect, useState } from "react"
import SearchCom from "../../Drawer/SearchCom"
import { Column, Row } from "style/preset"
import {  TipBoxWrap } from "../../Drawer/CommonComList"
import { useAppSelector } from "hooks/redux/hooks"
import { ChaingeChain } from "types/baseType"
import CImage from "components/CImage"

interface Props {
    open: boolean
    direction: string
    closeChange?: (isOpen: boolean) => void
    onComplete?: (obj?: any) => void
}

const DrawerChainsBrc20Com = ({open, direction, closeChange = (isOpen) => {}, onComplete = (obj) => {}}: Props) => {
    const { chainsForTokenFrom, chainsForTokenTo, chainsByBrc20: allChains } = useAppSelector((state) => state.app)
    const [ dataList, setDataList ] = useState<ChaingeChain[]>([])

    /**
     * 资源初始化
     */
    const [chains, setChains] = useState<ChaingeChain[]>([])
    const fnInit = useCallback(() => {
        if(open) {
            // 初始化资源
            let tempDataList = []
            if(direction === 'from' && chainsForTokenFrom && chainsForTokenFrom.length) {
                tempDataList = chainsForTokenFrom
            } else if(direction === 'to' && chainsForTokenTo && chainsForTokenTo.length) {
                tempDataList = chainsForTokenTo
            } else {
                tempDataList = allChains
            }
            setDataList(tempDataList)
            setChains(tempDataList)
        } else {
            // 清理资源
            setDataList([])
        }
    }, [allChains, chainsForTokenFrom, chainsForTokenTo, direction, open])

    useEffect(() => {
        fnInit()
    }, [fnInit])

    /**
     * 关闭回调
     */
    const [closeRandom, setCloseRandom] = useState(0)
    const fnClosed = (closed: boolean) => {
        closeChange(closed)
        setCloseRandom(0)
    }
    const fnCloseWin = useCallback(() => {
        setCloseRandom(closeRandom + 1)
    }, [closeRandom])

    /**
     * 搜索
     * @param e 
     */
    const fnSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        let filterVal = e.target.value
        filterVal = filterVal.toLowerCase()
        const tempList = chains.filter((item: ChaingeChain) => {
            return item.fullName.toLowerCase().includes(filterVal) || 
                item.nickName.toLowerCase().includes(filterVal) || 
                item.network.toLowerCase().includes(filterVal)
        })
        setDataList(tempList)
    }, [chains])

    /**
     * 选择资产
     */
    const fnSelectAsset = (curAsset: ChaingeChain) => {
        onComplete(curAsset)
        fnCloseWin()
    }

    return open ? <DrawerCom isOpen={open} closeRandom={closeRandom} onClose={fnClosed}>
        <DrawerContentWrap $isError={true}>
            <PaddingLeftRightWrap>
                <DrawerWinOneTileWrap>Select a chain</DrawerWinOneTileWrap>
                <DrawerWinTwoTileWrap $mb="30px">Choose any of our 55+ supported chains</DrawerWinTwoTileWrap>
                <SearchCom onChange={fnSearchChange}></SearchCom>
            </PaddingLeftRightWrap>
            
            <ScrollOutBoxWrap $height="calc(100% - 140px) !important;">
                <ListTopGradientWrap></ListTopGradientWrap>
                <ListBottomGradientWrap></ListBottomGradientWrap>
                <ScrollBoxWrap>
                    <StyledContainer $height="30px"></StyledContainer>
                    {
                        dataList.map((item: ChaingeChain, index) => <AssetsItemCom isBrc20={true} onClick={() => fnSelectAsset(item)} key={index} detail={item}></AssetsItemCom>)
                    }
                    <StyledContainer $height="30px"></StyledContainer>
                </ScrollBoxWrap>
            </ScrollOutBoxWrap>
        </DrawerContentWrap>
    </DrawerCom> : <></>
}


interface AssetsItemProps {
    detail: ChaingeChain
    isBrc20?: boolean
    onClick?: () => void
}

const AssetsItemCom = ({detail, isBrc20 = false, onClick}: AssetsItemProps) => {
    return <AssetsCardWrap onClick={onClick}>
        <Row $pointer $justifyContent="space-between" $flex1="1" $mr="8px">
            <Row>
                <CImage width="26px" height="26px" src={detail?.imgUrl as string}></CImage>
                <Column $ml="10px">
                    <StyledContainer $fontSize="16px" $lineHeight="18px">{detail.fullName}</StyledContainer>
                </Column>
            </Row>
            {/* <TrendingTagCom></TrendingTagCom> */}
        </Row>
        <TipBoxWrap $pl="8px" $pr="8px" $height="32px">
            <StyledContainer $fontSize="12px" $lineHeight="14px" $fontWeight6 $roobertSemiBold $color="#767A7F">{isBrc20 ? 'BRC20' : 'EVM'}</StyledContainer>
        </TipBoxWrap>
    </AssetsCardWrap>
}

const DrawerContentWrap = styled(StyledContainer)<{$isError: boolean}>`
    height: 100%;
    ${
        ({$isError, theme}) => $isError ? css`
         
        ` : css`
        `
    }
`

const AssetsCardWrap = styled(Row)`
    cursor: pointer;
    padding: 14px 20px;
    justify-content: space-between;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);
    border-radius: 9px;
    background-color: ${({theme}) => theme.basicWhite};
    margin-bottom: 10px;
    &:hover {
        box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
    }
`
export default DrawerChainsBrc20Com